import React from 'react';

export function CheckCheckIcon() {
  // https://lucide.dev/icons/check-check
  return (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 6 7 17l-5-5" />
      <path d="m22 10-7.5 7.5L13 16" />
    </g>
  );
}
